//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import searchFilterGalleryTemplate from '@legacy-components/filters/search-filter-gallery.html';

(function() {
  const curalate = angular.module('curalate');


    /**
     * Gallery to display and remove values for a given filter.
     */
  curalate.component('searchFilterGallery', {
    template: searchFilterGalleryTemplate,
    bindings: {
      filterExtractor: '&',
    },
    require: {
      searchFilter: '^searchFilter',
    },
    controllerAs: '$searchFilterGallery',
    controller: [
      '$scope',
      function(
                $scope,
            ) {
        const self = this;
        const cleanFilters = function(filters) {
          return _(filters).filter(filterValue => !!filterValue && !(filterValue.value === null || filterValue.value === undefined));
        };

        $scope.model = {
          filterValues: [],
        };

        $scope.model.removeFilter = function(filter) {
          self.searchFilter.removeValue(filter);
        };

        $scope.model.removeAllFilters = function() {
          self.searchFilter.removeValues($scope.model.filterValues);
        };

        $scope.model.printFilter = function(filter) {
          return self.filterExtractor ? self.filterExtractor()(filter) : filter.value;
        };

        this.$onInit = function() {
          $scope.model.filterValues = cleanFilters(self.searchFilter.getValue());
          $scope.model.lockedKey = self.searchFilter.isKeyLocked();

          self.searchFilter.getFilterValueStream().subscribe((newFilterValues) => {
            $scope.model.filterValues = cleanFilters(newFilterValues);
          });
        };
      },
    ],
  });
})();
